import api from '@/utils/api';
import {
    GET_LIST_RECEIPTS,
    GET_SPECIFIC_RECEIPT,
    UPDATE_SPECIFIC_RECEIPT,
    CREATE_NEW_RECEIPT,
    REMOVE_RECEIPTS,
    GET_ACTIVE_RECEIPTS,
    GET_RECEIPTS_BY_CUSTOMER,
    EXPORT_RECEIPTS_EXCEL
} from './types';
import { NotificationManager } from 'react-notifications';

const RECEIPTS_ENDPOINT = '/receipts';

const notifyCommissionProcessing = data => {
    const results = [data?.commission_processing]
        .concat(data?.balance_commission_processing || [], data?.deposit_commission_processing || [])
        .filter(Boolean);
    const pending = results.find(result => ['PENDING', 'WAITING', 'FAILED_RETRY'].includes(result.status));
    if (pending) {
        NotificationManager.warning(pending.message || 'Phiếu thu đã ghi nhận; hoa hồng đang chờ hệ thống xử lý lại.');
    }
};

export const getListReceipts = (filter) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api.get(RECEIPTS_ENDPOINT, { params: filter })
            .then((res) => {
                dispatch({ type: GET_LIST_RECEIPTS, payload: res.data.data });
                resolve(res.data);
            })
            .catch((err) => {
                console.log(err);
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};


export const getActiveReceipts = (filter) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api.get(`${RECEIPTS_ENDPOINT}/active`, { params: filter })
            .then((res) => {
                dispatch({
                    type: GET_ACTIVE_RECEIPTS,
                    payload: res.data.data
                });
                resolve(res.data);
            })
            .catch((err) => {
                console.log(err);
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const getReceipt = (id) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api.get(`${RECEIPTS_ENDPOINT}/${id}`)
            .then((res) => {
                dispatch({ type: GET_SPECIFIC_RECEIPT, payload: res.data.data });
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const getReceiptsByCustomer = (id) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api.get(`${RECEIPTS_ENDPOINT}/customer/${id}`)
            .then((res) => {
                dispatch({ type: GET_RECEIPTS_BY_CUSTOMER, payload: res.data.data });
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const createReceipt = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api.post(RECEIPTS_ENDPOINT, data)
            .then((res) => {
                dispatch({ type: CREATE_NEW_RECEIPT, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                notifyCommissionProcessing(res.data.data);
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const updateReceipt = (id, data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api.put(`${RECEIPTS_ENDPOINT}/${id}`, data)
            .then((res) => {
                dispatch({ type: UPDATE_SPECIFIC_RECEIPT, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                notifyCommissionProcessing(res.data.data);
                resolve(res.data);
            })
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const previewReceiptMutation = (id, data) => () => {
    return new Promise((resolve, reject) => {
        return api.post(`${RECEIPTS_ENDPOINT}/${id}/mutation-preview`, data)
            .then((res) => resolve(res.data.data))
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const previewReceiptCancellation = id => () => {
    return new Promise((resolve, reject) => {
        return api.post(`${RECEIPTS_ENDPOINT}/${id}/cancellation-preview`)
            .then((res) => {
                resolve(res.data.data || {});
            })
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg || 'Không thể kiểm tra điều kiện hủy phiếu thu. Vui lòng thử lại.');
                reject(err);
            });
    });
};

export const cancelReceipt = (id, data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api.post(`${RECEIPTS_ENDPOINT}/${id}/cancel`, data)
            .then((res) => {
                dispatch({ type: REMOVE_RECEIPTS, payload: [id] });
                NotificationManager.success(res.data.msg);
                resolve(res.data.data || {});
            })
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg || 'Không thể hủy phiếu thu. Vui lòng tải lại danh sách và thử lại.');
                reject(err);
            });
    });
};

export const exportReceiptsExcel = (filter) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .post(`${RECEIPTS_ENDPOINT}/export`, filter)
            .then((res) => {
                dispatch({ type: EXPORT_RECEIPTS_EXCEL, payload: res.data.data });
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const getReceiptHistory = id => () => {
    return api.get(`${RECEIPTS_ENDPOINT}/${id}/history`)
        .then(res => res.data.data || [])
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Không thể tải lịch sử phiếu thu.');
            return Promise.reject(err);
        });
};

export const getCustomerFinanceSummary = (customerId, receiptId = null) => () => {
    return new Promise((resolve, reject) => {
        return api.get(`/customer-finance/customer/${customerId}`, {
            params: receiptId ? { receipt_id: receiptId } : {}
        }).then((res) => {
            resolve(res.data.data || {});
        }).catch((err) => {
            NotificationManager.error(err.response?.data?.msg || 'Không thể tải nguồn hoàn tiền.');
            reject(err);
        });
    });
};

export const getCustomerDepositSummary = customerId => () => {
    return new Promise((resolve, reject) => {
        return api.get(`/customer-finance/deposits/customer/${customerId}`).then((res) => {
            resolve(res.data.data || {});
        }).catch((err) => {
            NotificationManager.error(err.response?.data?.msg || 'Không thể tải thông tin tiền đặt cọc.');
            reject(err);
        });
    });
};

export const refundCustomer = (data) => () => {
    return new Promise((resolve, reject) => {
        return api.post('/customer-finance/refunds', data).then((res) => {
            NotificationManager.success(res.data.msg || 'Đã ghi nhận hoàn tiền cho khách.');
            resolve(res.data.data);
        }).catch((err) => {
            NotificationManager.error(err.response?.data?.msg || 'Không thể hoàn tiền cho khách.');
            reject(err);
        });
    });
};

export const applyCustomerBalance = data => () => {
    return new Promise((resolve, reject) => {
        return api.post('/customer-finance/apply-balance', data).then((res) => {
            NotificationManager.success(res.data.msg || 'Đã sử dụng số dư cho dịch vụ.');
            resolve(res.data.data);
        }).catch((err) => {
            NotificationManager.error(err.response?.data?.msg || 'Không thể sử dụng số dư cho dịch vụ.');
            reject(err);
        });
    });
};

const runDepositCommand = (url, data, successMessage, errorMessage) => () => {
    return new Promise((resolve, reject) => {
        return api.post(url, data).then((res) => {
            NotificationManager.success(res.data.msg || successMessage);
            resolve(res.data.data);
        }).catch((err) => {
            NotificationManager.error(err.response?.data?.msg || errorMessage);
            reject(err);
        });
    });
};

export const receiveCustomerDeposit = data => runDepositCommand(
    '/customer-finance/deposits', data, 'Đã ghi nhận tiền khách đặt cọc.', 'Không thể ghi nhận tiền đặt cọc.'
);

export const applyCustomerDeposit = data => runDepositCommand(
    '/customer-finance/deposits/apply', data, 'Đã sử dụng tiền cọc cho dịch vụ.', 'Không thể sử dụng tiền đặt cọc.'
);

export const refundCustomerDeposit = data => runDepositCommand(
    '/customer-finance/deposits/refund', data, 'Đã trả tiền cọc cho khách.', 'Không thể trả tiền đặt cọc.'
);

export const getCustomerFundTransferSources = customerId => () => api
    .get('/customer-fund-transfers/sources', { params: { customer_id: customerId } })
    .then(res => res.data.data || {})
    .catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể tải nguồn chuyển tiền.');
        return Promise.reject(err);
    });

export const createCustomerFundTransfer = data => () => api.post('/customer-fund-transfers', data)
    .then(res => {
        NotificationManager.success(res.data.msg || 'Đã chuyển nguồn tiền.');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể chuyển nguồn tiền.');
        return Promise.reject(err);
    });

export const reverseCustomerFundTransfer = (id, data) => () => api
    .post(`/customer-fund-transfers/${id}/reversal`, data)
    .then(res => {
        NotificationManager.success(res.data.msg || 'Đã đảo phần nguồn còn lại.');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể đảo giao dịch chuyển.');
        return Promise.reject(err);
    });
